<form [formGroup]="formulario">
  <div class="row">
    <div class="col-1">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>ID</mat-label>
        <input formControlName="id" matInput readonly>
      </mat-form-field>
    </div>
    <div class="col-5">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Descrição</mat-label>
        <input formControlName="descricao" matInput required>
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Data de Início</mat-label>
        <input formControlName="dataInicio" matInput type="date" required>
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Data de Término</mat-label>
        <input formControlName="dataTermino" matInput type="date" required>
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Ativo</mat-label>
        <mat-select formControlName="ativo" required>
          <mat-option [value]="true">Sim</mat-option>
          <mat-option [value]="false">Não</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>URL / Link</mat-label>
        <input formControlName="url" matInput>
      </mat-form-field>
    </div>
    <div class="col-6">
      <label class="d-block mb-2">Imagem do Banner</label>
      <input type="file" class="file-upload" accept="image/*" (change)="anexarArquivo.emit($event)">
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-6">
      <mat-card class="image-preview-card">
        <mat-card-header><mat-card-title>Prévia da Imagem</mat-card-title></mat-card-header>
        <mat-card-content class="text-center p-3">
          <div *ngIf="bannerBase64; else noImage" style="max-height:200px;display:flex;align-items:center;justify-content:center;">
            <img [src]="bannerBase64" style="max-width:100%;max-height:200px;object-fit:contain;" alt="Banner">
          </div>
          <ng-template #noImage>
            <div style="height:200px;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#999;">
              <mat-icon style="font-size:48px;width:48px;height:48px;">image</mat-icon>
              <p class="mt-2">Nenhuma imagem selecionada</p>
            </div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</form>
